export default "__VITE_ASSET__pQDvKrwI__"